import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import ModuleAuthLayout from "./authLayout";
import ModuleGlobal from "./global";
import ModuleOrganizations from "./organizations";
import ModuleUser from "./user";
import ModuleOrgManagement from "./orgManagement";
import ModuleUserManagement from "./userManagement";
import ModuleDisconnectHistory from "./disconnectHistory";
import ModuleTOUTransactionHistory from "./touTransactionHistory";
import ModulePricingHistory from "./pricingHistory";
import ModuleStationOCPPLogs from "./stationOCPPLogs";
import { getModule } from "vuex-module-decorators";

Vue.use(Vuex);

const moduleDefinitions = {
  AuthLayout: ModuleAuthLayout,
  Global: ModuleGlobal,
  DisconnectHistory: ModuleDisconnectHistory,
  TOUTransactionHistory: ModuleTOUTransactionHistory,
  OrgManagement: ModuleOrgManagement,
  UserManagement: ModuleUserManagement,
  Organizations: ModuleOrganizations,
  StationOCPPLogs: ModuleStationOCPPLogs,
  User: ModuleUser,
  PricingHistory: ModulePricingHistory
};

const store = new Vuex.Store({
  modules: moduleDefinitions,
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      paths: ["Organizations", "OrgManagement"]
    }),
    createPersistedState({
      storage: window.localStorage,
      paths: ["Global"]
    })
  ]
});

export default store;
export const GlobalStore = getModule(ModuleGlobal, store);
export const OrgManagementStore = getModule(ModuleOrgManagement, store);
export const userManagementStore = getModule(ModuleUserManagement, store);
export const OrganizationsStore = getModule(ModuleOrganizations, store);
export const DisconnectHistoryStore = getModule(ModuleDisconnectHistory, store);
export const TOUTransactionHistoryStore = getModule(ModuleTOUTransactionHistory, store);
export const PricingHistoryStore = getModule(ModulePricingHistory, store);
export const StationOCPPLogsStore = getModule(ModuleStationOCPPLogs, store);
export const UserStore = getModule(ModuleUser, store);
export const AuthLayoutStore = getModule(ModuleAuthLayout, store);
